import { render, staticRenderFns } from "./ModalEditTotem.vue?vue&type=template&id=4c7c8893&"
import script from "./ModalEditTotem.vue?vue&type=script&lang=js&"
export * from "./ModalEditTotem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports